// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-tabs[data-v-188a5c81] .v-tabs-slider-wrapper{display:block!important}.fit-pack[data-v-188a5c81]{background-color:rgba(135,235,230,.25)!important}", ""]);
// Exports
module.exports = exports;
